import { Box, Typography } from "@mui/material";
import SafeSummaryTile from "./SafeSummaryTile";
import { useSafeWorkspace } from "./safeWorkspace";

// Read-only metrics stay unframed so they cannot be mistaken for filter cards.
export function SummaryMetric({ label, value, helper, color = "text.primary" }) {
  const workspace = useSafeWorkspace();
  if (workspace) return <SafeSummaryTile label={label} value={value} helper={helper} color={color === "text.primary" ? "grey" : color} />;
  const valueColor = ["primary", "secondary", "success", "warning", "error", "info"].includes(color)
    ? `${color}.main`
    : color;

  return (
    <Box
      component="dl"
      data-safe-summary="metric"
      sx={{
        m: 0,
        px: { xs: 1.5, md: 2 },
        py: 1.25,
        minWidth: 0,
        height: "100%",
        boxSizing: "border-box",
        borderLeft: "1px solid",
        borderColor: "divider",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        gap: 0.5,
      }}
    >
      <Typography component="dt" sx={{ fontSize: 13, color: "text.secondary", lineHeight: 1.5 }}>
        {label}
      </Typography>
      <Typography component="dd" sx={{ m: 0, fontSize: 24, fontWeight: 700, color: valueColor, lineHeight: 1.25, fontVariantNumeric: "tabular-nums", overflowWrap: "anywhere" }}>
        {value}
      </Typography>
      {helper ? <Typography component="dd" sx={{ m: 0, fontSize: 12, color: "text.secondary", lineHeight: 1.5 }}>{helper}</Typography> : null}
    </Box>
  );
}
